import React from "react";
import { Box, Button, Card, CardContent, Chip, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const BlogCard = ({ title, summary, category, cover, to }) => (
  <Card
    sx={{
      height: "100%",
      border: "1px solid var(--color-border)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      background:
        "linear-gradient(180deg, rgba(255,255,255,0.98), rgba(252,248,242,0.96))",
      transition: "transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease",
      "&:hover": {
        transform: "translateY(-6px)",
        boxShadow: "var(--shadow-soft)",
        borderColor: "rgba(183, 132, 69, 0.24)",
      },
    }}
  >
    <Box
      sx={{
        aspectRatio: "16 / 10",
        backgroundImage: `linear-gradient(180deg, rgba(18, 32, 51, 0.08), rgba(18, 32, 51, 0.48)), url(${cover})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    />
    <CardContent
      sx={{
        p: { xs: 2.85, md: 3.3 },
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <Chip
        label={category}
        size="small"
        sx={{
          mb: 2,
          alignSelf: "flex-start",
          bgcolor: "rgba(184,134,70,0.14)",
          color: "primary.dark",
        }}
      />
      <Typography variant="h5" sx={{ mb: 1.25, maxWidth: "18ch" }}>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
        {summary}
      </Typography>
      <Button
        component={RouterLink}
        to={to}
        sx={{
          mt: 2.5,
          px: 0,
          minHeight: "auto",
          alignSelf: "flex-start",
          color: "secondary.main",
        }}
      >
        View Article
      </Button>
    </CardContent>
  </Card>
);

export default BlogCard;
